module.exports = __webpack_public_path__ + "static/img/input.abb622c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/input.png
// module id = i1Yn
// module chunks = 1